export const POIS_FILTERS = {
  combobox: { type: 'combobox' },
  mosaic: { type: 'mosaic' },
  multichip: { type: 'multichip' },
  multicombobox: { type: 'multicombobox' },
  multidatepicker: { type: 'multidatepicker' },
  numberpicker: { type: 'numberpicker' },
  slider: { type: 'slider' }
}

export const HOTEL_DATEPICKER_ID = 'multidatepicker-dates'
export const HOTEL_NUMBERPICKER_ID = 'numberpicker-voyageurs'

export const DEFAULT_FILTER_COMBOBOX_PARAMETER_VALUE = 'discarded'
